import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Grid";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import IconButton from "@mui/material/IconButton";
import { translate } from "../../utils/utils";
import GlobalInformationCard from "../../components/useCase/GlobalInformationsCard";
import { useMediaQuery } from "@mui/material";
import moment from "moment";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function WeaknessesDetails({
  open,
  handleClose,
  rowDetails,
  // disabled,
  // handleOpen,
  // handleUpdate,
  id_owner,
  company,
  show,
}) {
  const { t } = useTranslation();

  // const [rowDetails, setRowDetails] = useState({});

  // useEffect(() => {
  //   if (id) {
  //     setRowDetails(data.filter((el) => el.id === id)[0]);
  //   }
  // }, [data, id]);
  const isMobile = useMediaQuery("(max-width:1400px)");
  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        fullWidth
        onClose={handleClose}
        maxWidth="md"
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          sx: { padding: "10px 10px ", backgroundColor: "#F3F9F8" },
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "start",
          }}
        >
          <Typography
            variant="subtitle3"
            sx={{ display: "flex", alignItems: "center" }}
          >
            <IconButton onClick={handleClose}>
              <KeyboardBackspaceIcon sx={{ width: "70%", color: "black" }} />
            </IconButton>
            {t("back")}
          </Typography>
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            <GlobalInformationCard
              label="Source"
              value={
                rowDetails.source === id_owner ? company : rowDetails.source
              }
            />

            <GlobalInformationCard
              label="Date"
              value={moment(rowDetails.last_update).format("DD-MM-YYYY")}
            />
          </div>
        </div>
        <DialogTitle>
          <Grid container alignItems="center">
            <Grid item xs={9}>
              <Typography
                variant="accordion1"
                sx={{
                  fontSize: !isMobile ? "30px" : "25px",
                  lineHeight: "15.2px",
                }}
              >
                {rowDetails?.[translate("title")] || t("not_specified")}
              </Typography>
            </Grid>
            {/* <Grid item xs={3} align="right">
              <Button
                variant="contained"
                color="button"
                fullWidth
                size="small"
                disabled={disabled}
                onClick={() => {
                  handleOpen();
                  handleUpdate();
                }}
                sx={{ height: "40px", width: "70%" }}
              >
                <ModeEditOutlineOutlinedIcon /> &nbsp; {t("edit")}
              </Button>
            </Grid> */}
          </Grid>
        </DialogTitle>
        <DialogContent>
          {/* <Typography variant="title4" sx={{ fontSize: "20px" }}>
            Source
          </Typography> */}

          {/* <Typography mb={2} sx={{ fontSize: "14px" }}>
            {rowDetails.source === id_owner ? company : rowDetails.source}
          </Typography> */}
          <Typography
            variant="title4"
            sx={{ fontSize: "20px", color: "#b7b7b7db" }}
          >
            Description
          </Typography>
          <Typography mt={1} sx={{ fontSize: "13px", fontWeight: "800" }}>
            {rowDetails?.[translate("description")] || t("not_specified")}
          </Typography>

          <Typography
            variant="title4"
            mt={1}
            sx={{ fontSize: "20px", color: "#b7b7b7db" }}
          >
            Tags
          </Typography>
          {/* <div style={{ display: "flex", alignItems: "center" }}>
            {rowDetails?.tags?.map((tag, index) => (
              <Typography mt={1} sx={{ fontSize: "13px", fontWeight: "800" }}>
                {index + 1 === rowDetails?.tags?.length ? tag : `${tag},\u00A0`}
              </Typography>
            ))}
          </div> */}

          <Grid container>
            {rowDetails?.tags?.map((tag) => (
              <Grid item xs={12}>
                <Typography mt={1} sx={{ fontSize: "13px", fontWeight: "800" }}>
                  {tag}
                </Typography>
              </Grid>
            ))}
          </Grid>
        </DialogContent>
      </Dialog>
    </div>
  );
}
